export const PromotionPackageServices = [
  { id: 4, name: 'SUPER VIP', bgColor: '#FD541A', iconName: 'vip-super-1' },
  { id: 2, name: 'VIP', bgColor: '#3C74FF', iconName: 'vip-basic' },
  { id: 3, name: 'VIP PLUS', bgColor: '#FCC000', iconName: 'vip-plus' },
  { id: 5, name: 'COLOR', bgColor: '#59D8C9', iconName: 'color-i' },
  { id: 7, name: 'AUTO UPDATE', bgColor: '#BB5CF7', iconName: 'automatic-update-promo-icon' },
  { id: 6, name: 'UPDATE', bgColor: '#27B1FF', iconName: 'one-time-update-promo-icon' },
];

